import React from "react";
import { Nav, Navbar } from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap'
import logo from "../img/logo.png";
import navBg from "../img/navbg.jpg";

const navStyle = {
    backgroundColor:'#151515',
    background:'url(' + navBg + ')'
  };

  const aStyle = {
    textAlign:'center'
  };

function Navi() {
    return (
      <div className="App">
        <Navbar fixed="top" style={navStyle} variant="dark" expand="lg" collapseOnSelect>
          <Navbar.Brand>
          <LinkContainer to="/">
            <Nav.Link><img src={logo} width="250px"/>{' '}</Nav.Link>
            </LinkContainer>
          </Navbar.Brand>
  
          <Navbar.Toggle className="coloring" />
          <Navbar.Collapse>
            <Nav>
              <LinkContainer to="/map">
                <Nav.Link>MAP</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/gallery">
                <Nav.Link>MY TREASURES</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/explore">
                <Nav.Link>EXPLORE</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/makeNFT" className="btnBg" style={aStyle}>
                <Nav.Link>ABRACADABRA</Nav.Link>
              </LinkContainer>
            </Nav>
          </Navbar.Collapse>
  
        </Navbar>
      </div>
    );
  }
  
  export default Navi;